import { render, staticRenderFns } from "./FormularioControlNiño.vue?vue&type=template&id=4ab06066&scoped=true"
import script from "./FormularioControlNiño.vue?vue&type=script&lang=js"
export * from "./FormularioControlNiño.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab06066",
  null
  
)

export default component.exports